import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/404.png';
const _withScopeId = n => (_pushScopeId("data-v-04df9034"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "not-found",
  "data-ssrcache": "never"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "error404-img",
  src: _imports_0,
  alt: "error"
}, null, -1));
const _hoisted_3 = {
  class: "sorry-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_hoisted_2, _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.msg), 1), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]);
}